import { post } from "../utils/http-h5"
import { setEcJumpUrl } from "../utils/ec"
const LOCAL_USER_TOKEN_KEY = "ec_user_token";
const LOCAL_USER_CLIENT_KEY = "ec_user_client";

function getToken() {
    return sessionStorage.getItem(LOCAL_USER_TOKEN_KEY);
}
function getClient() {
    return sessionStorage.getItem(LOCAL_USER_CLIENT_KEY);
}

function isLogin() {
    return new Promise((resolve, reject) => {
        let token = getToken();
        if (token) {
            resolve(token)
        } else {
            reject({
                errorCode: 401
            });
        }
    });
}

function notFound(router) {
    logout()
    router.push("/404")
}

function setToken(token) {
    sessionStorage.setItem(LOCAL_USER_TOKEN_KEY, token);
}

function setClient(client) {
    sessionStorage.setItem(LOCAL_USER_CLIENT_KEY, client);
}

function ecLogin({ code, client, cardProductName, cardLevel, cardBin, cardId }) {
    const url = "/v1/ec/member";
    const data = {
        code, client, cardProductName, cardLevel, cardBin, cardId
    }
    return post({ url, data });
}

function login({ code, client, cardProductName, cardLevel, cardBin, cardId, jumpUrl }) {
    return new Promise((resolve, reject) => {
        if (code && client) {
            const data = {
                code, client, cardProductName, cardLevel, cardBin, cardId
            }
            ecLogin(data).then(token => {
                setToken(token);
                setClient(client);
                setEcJumpUrl(jumpUrl);
                resolve(token);
            }, reject);
        } else {
            let token = getToken();
            if (token) {
                resolve(token)
            } else {
                reject({
                    errorCode: 401
                });
            }
        }
    })
}

function logout() {
    sessionStorage.removeItem(LOCAL_USER_TOKEN_KEY);
}

export default {
    login,
    logout,
    getToken,
    setToken,
    getClient,
    isLogin,
    notFound
}